(function (argument) {
	'use strict';

	angular.module("changdobels")
		.component("cdContactPhone", {
			templateUrl: ['TEMPLATE_URL', function (TEMPLATE_URL) {
				return TEMPLATE_URL + '/templates/contact-phone.html';
			}]
		});
})();